import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-format-italic",
  "use": "icon-format-italic-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-format-italic\">\n<path d=\"M12 7H14L11 17H9L12 7Z\" fill=\"currentColor\" />\n<rect x=\"9\" y=\"7\" width=\"7\" height=\"2\" rx=\"1\" fill=\"currentColor\" />\n<rect x=\"7\" y=\"15\" width=\"7\" height=\"2\" rx=\"1\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol